import { useEffect, useState } from 'react';
import './whatsapp.css';

function WhatsAppButton() {
  const [showMessage, setShowMessage] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowMessage(false);
    }, 4000); // 🔥 4 segundos

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="whatsapp-wrapper">

      {/* 🔥 MENSAJE */}
      <div className={`whatsapp-message ${showMessage ? 'visible' : ''}`}>
        ¿Necesitas ayuda? Chatea con nosotros
      </div>

      {/* 🔥 BOTÓN */}
      <a
        href="https://wa.me/573024660543"
        target="_blank"
        rel="noreferrer"
        className="whatsapp-btn"
      >
        <img src="https://cdn-icons-png.flaticon.com/512/733/733585.png" alt="whatsapp" />
      </a>

    </div>
  );
}

export default WhatsAppButton;